import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import backArrow from '../assets/img/BackArrow.svg';
import circleFill from '../assets/img/circle-fill.svg';
import logoutIcon from '../assets/img/download.svg';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Header = ({ sidebarCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { instance } = useMsal();

  // Dynamically set page name with path structure
  let pagePathElements = [];
  switch (location.pathname) {
    case '/app/CreateSignature':
      pagePathElements = [
        { text: 'Home', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Generate Email Signature', isPath: false }
      ];
      break;
    case '/app/AddressMaster':
      pagePathElements = [
        { text: 'Home', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Master', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Address Master', isPath: false }
      ];
      break;
    case '/app/UserMaster':
      pagePathElements = [
        { text: 'Home', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Admin', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'User Master', isPath: false }
      ];
      break;
    case '/app/RoleMaster':
      pagePathElements = [
        { text: 'Home', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Admin', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Role & Authorization', isPath: false }
      ];
      break;
    case '/app/AuditLog':
      pagePathElements = [
        { text: 'Home', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Admin', isPath: true },
        { text: ' / ', isPath: true },
        { text: 'Audit Log', isPath: false }
      ];
      break;
    default:
      pagePathElements = [];
  }

  const sessionEmail = (sessionStorage.getItem("userEmail") || "").split("@")[0];
  const userDisplayName = sessionStorage.getItem("userDisplayName") || sessionEmail || "";
  
  // Function to get user initials
  const getUserInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return words.slice(0, 2).map(word => word.charAt(0).toUpperCase()).join("");
  };

  const userInitials = getUserInitials(userDisplayName);

  const handleLogout = async () => {
    // GS-SEC-029: Proper token invalidation on logout
    try {
      const sessionToken = sessionStorage.getItem("gs_session_token");
      await fetch((process.env.REACT_APP_API_BASE_URL || '') + '/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(sessionToken ? { 'Authorization': `Bearer ${sessionToken}` } : {})
        }
      });
    } catch (e) { /* ignore logout API errors */ }

    // Clear all session and local storage
    sessionStorage.clear();
    localStorage.clear();

    // MSAL logout - revokes Azure AD session and redirects to login
    try {
      await instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin + '/' });
    } catch (e) {
      // Fallback if MSAL logout fails
      navigate('/');
    }
  };

  useEffect(() => {
    const bootstrap = window.bootstrap;
    if (bootstrap && document.querySelectorAll('.dropdown-toggle').length) {
      const dropdownElements = document.querySelectorAll('.dropdown-toggle');
      dropdownElements.forEach((el) => {
		  //sonar fix start
        //new bootstrap.Dropdown(el);
		//sonar fix end
		void new bootstrap.Dropdown(el);
      });
    }
  }, []);

  return (
    <>
   <nav className="navbar navbar-default custom-header-height" id="indexHead" style={{ display: 'flex', alignItems: 'stretch', height: '48px' }}>
      <div className="container-fluid" style={{ display: 'flex', alignItems: 'stretch', position: 'relative', height: '100%' }}>

        <span
          className="navbar-brand title-txt"
          style={{ fontFamily: 'GB-Headline', color: '#810055', margin: '-8px 0 0 0' }}
        >Godrej Signature</span>
        
        <div className="user-info-section" style={{ height: '100%', marginTop: '-5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img 
              src={circleFill} 
              alt="User Avatar" 
              style={{
                width: '32px',
                height: '32px',
                filter: 'brightness(0) saturate(100%) invert(96%) sepia(8%) saturate(463%) hue-rotate(287deg) brightness(102%) contrast(96%)'
              }}
            />
            <span style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: '#810055',
              fontSize: '11px',
              fontWeight: 'bold',
              fontFamily: 'GB-BodyCopy'
            }}>
              {userInitials}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: '1.2' }}>
            <span style={{
              fontSize: '13px',
              fontWeight: 'bold',
              color: '#333',
              fontFamily: 'GB-BodyCopy',
              textTransform: 'uppercase'
            }}>
              {userDisplayName}
            </span>
            <span style={{
              fontSize: '11px',
              color: '#707070',
              fontFamily: 'GB-BodyCopy'
            }}>
              {sessionStorage.getItem("userEmail") || ""}
            </span>
          </div>
          <button 
            onClick={handleLogout}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Logout"
          >
            <img 
              src={logoutIcon} 
              alt="logout" 
              style={{
                width: '18px',
                height: '18px',
                transform: 'rotate(-90deg)',
                filter: 'invert(45%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(90%)'
              }}
            />
          </button>
        </div>
      </div>
    </nav>
    <div style={{ height: '30px', backgroundColor: '#ffffff', borderBottom: '1px solid #e7e7e7', display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
      <span style={{ fontFamily: 'GB-Headline', fontSize: '14px' }}>
        {pagePathElements.map((element, index) => (
          <span 
            key={index} 
            style={{ 
              color: element.isPath ? '#707070' : '#000000' 
            }}
          >
            {element.text}
          </span>
        ))}
      </span>
    </div>
    </>
  );
};

export default Header;
